
import { Select, Option } from "element-ui"
import { cancelOrder, getOrderList } from "../api/order"
import getCartNumMixin from "@/mixins/getCartNum"

import orderListRow from "@/components/order/orderListRow.vue"
import pagination from "@/components/ware-view/pagination.vue"
export default {
  components: {
    orderListRow,
    pagination,
    [Select.name]: Select,
    [Option.name]: Option
  },
  mixins: [getCartNumMixin],
  provide() {
    return {
      cascaderAsync: () => this.cascaderData
    }
  },
  props: {},
  data() {
    return {
      isOnline: false,
      defaultSel: 1,
      options: [
        {
          value: 1,
          label: this.$t("order.lastThreeMonths")
        },
        {
          value: 2,
          label: this.$t("order.threeMonthsAgo")
        }
      ],
      activeTabs: "web",
      orderList: [],
      defaultPageInfo: { pageNum: 1, pageSize: 9 },
      orderPageInfo: { pageNum: 1, pageSize: 9 },
      hadRequest: false,
      loadingInstance: null,
      placeholder: this.$t("order.pleaseSelect"),
      pageNum: 1
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  async mounted() {
    document.title = this.$t("pageTitle.order_list")
    const params = window.location.href.split("?")[1]
    this.pageNum = params ? params.split("=")[1] : 1
    await this.init()
  },
  methods: {
    init() {
      this.getOrderListFun(this.pageNum, this.defaultSel)
    },

    async getOrderListFun(pageNum, time) {
      let pageInfoCur = {}
      pageInfoCur = this.defaultPageInfo
      this.hadRequest = false
      try {
        const res = await getOrderList({
          param: JSON.stringify({
            pageSize: pageInfoCur.pageSize || 20,
            pageNum: pageNum || pageInfoCur.pageNum || 1,
            orderOrigin: 2,
            dataRange: time || 1
          })
        })

        const { orderList, pageInfo } = res.data
        this.orderList = orderList
        this.orderPageInfo = pageInfo || this.defaultPageInfo
        return res
      } catch (error) {
        console.log(error)
      } finally {
        this.hadRequest = true
      }
    },
    handleTimeChange(data) {
      this.getOrderListFun(1, data)
    },
    async handleCancleSave(param) {
      await cancelOrder({
        param: JSON.stringify({
          orderId: param.orderId
        })
      })
    }
  }
}
